/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, IconButton} from '@salesforce/retail-react-app/app/components/shared/ui'
import usePromoCodeFields from './usePromoCodeFields'
import Field from '../field'
import {ChevronRightIcon} from '../custom-icons'
import {useIntl} from 'react-intl'

const PromoCodeFields = ({form, prefix = '', ...props}) => {
    const fields = usePromoCodeFields({form, prefix})
    const intl = useIntl()
    const code = form.watch('code')

    return (
        <Box {...props}>
            <Field inputProps={{flex: 1}} {...fields.code} type="text">
                <IconButton
                    type="submit"
                    variant={'primary'}
                    isLoading={form.formState.isSubmitting}
                    disabled={code?.length < 3}
                    icon={<ChevronRightIcon boxSize="12px" />}
                    w={50}
                    aria-label={intl.formatMessage({
                        id: 'promo_code_fields.button.apply',
                        defaultMessage: 'Apply'
                    })}
                />
            </Field>
        </Box>
    )
}

PromoCodeFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default PromoCodeFields
